/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */
import React from "react"
import {
    ContentSection,
    Modal,
    TitleSection,
    ModalTitle,
    Row,
    Color,
    Chip,
} from "trux"

export const SelectFilterDialog = ({
    title,
    open,
    setOpen,
    value,
    options,
    onValueChanged,
    parent,
}) => {
    const onChange = (value) => {
        onValueChanged(value)
        setOpen(false)
    }

    const getColor = (option) => {
        if (option.value === value) {
            return Color.White2
        } else if (option.disabled === true) {
            return Color.Grey2
        } else {
            return Color.Black
        }
    }

    return (
        <Modal
            trkContext={`${title} Filter Dialog`}
            open={open}
            onShadeClick={() => setOpen(false)}
            parent={parent}
        >
            <TitleSection onCloseClick={() => setOpen(false)}>
                <ModalTitle content={title} />
            </TitleSection>
            <ContentSection>
                <Row justifyContent="center" spacingBottom="4">
                    {options.map((option) => (
                        <Chip
                            key={option.value}
                            content={option.title}
                            background={
                                option.value === value
                                    ? Color.Black
                                    : Color.Grey4
                            }
                            color={getColor(option)}
                            fat={true}
                            marginRight="2"
                            marginBottom="2"
                            trkAction={`${options.title} Selected`}
                            onClick={() => {
                                if (!option.disabled) {
                                    onChange(option.value)
                                }
                            }}
                        />
                    ))}
                </Row>
            </ContentSection>
        </Modal>
    )
}
